<template>
    
    <spinner v-if="!loaded" ></spinner>

    <div class="users-template template-page" v-else-if="loaded" > 
        
        <clicksComponent v-if="rows" :data="rows" ></clicksComponent>
                
    </div>
</template>

<script>
    
import clicksComponent from '../../components/clicks.vue' 
import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import moment from 'moment'
import helper from '@/helpers/helpers.js';
    
import axios from 'axios'

export default{
    name: "LeadTags",
    components:{
        clicksComponent
    },
    props: {
        ID: { 
            type: [Number, String],
        }
    },
    data () {
        return {
            filter: '',
            columns: [
                {
                    label: 'Tag',
                    field: 'tag'
                    //field: this.returnName,
                },
                {
                    label: 'Name',
                    field: 'name'
                    //field: this.returnName,
                },
                {
                    label: 'Date',
                    field: this.returnDate,
                },
            ],
            rows: [],
            loaded: false,
        }
    },
    beforeCreate: function (){
       // this.$store.dispatch(GET_USERS);
    },
    mounted: function(){
        this.get_data();
        
    },
    computed: {
    },
    methods: {
        get_data_old(){
          
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passed_organizationID )
            
            const db = firebase.firestore();
            //var ref = db.collection('organizations/'+orgID+'/leads/'+this.ID+'/clicks').orderBy('datetime', 'desc');
            var ref = db.collection('organizations/'+orgID+'/events/').where( 'leadID',"==",this.ID ).orderBy('datetime', 'desc');

            return ref.get()
                .then((snapshot) => {
                    let results = [];
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                                results.push( item )
                                //console.log(item)
                                
                                this.rows = results
                                
                            
                                return results;
                        })
                    )
                    .then(results => {                        
                        //return results; 
                        this.loaded = true;
                    })

                })
            
        },
        
        get_data(){
            
            axios({ 
                method: 'post',
                url: 'https://sql.theatlass.com/api/get_clicks.php?',
                headers: { 
                    'Access-Control-Allow-Headers': '*', 
                    'Access-Control-Allow-Origin': '*',  
                    'Content-Type': 'application/json;' 
                },
                data: { 
                    "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                    //"startDate":  moment.utc(day).format('YYYY-MM-DD 00:00:00'),
                    //"endDate":  moment.utc(day).format('YYYY-MM-DD 23:59:59'),
                    //"startDate":  start,
                    //"endDate":  end,
                    "leadID": this.ID,
                    //"filters":  { key: "email", operator: "!=", value: "" }
                } 
            })
            .then(resp => {
                //console.log(resp)
                if( resp.status == 200 ){
                    let response_data = resp.data.data.results
                                      
                    //console.log(response_data)
                    //PROCESS DATA
                    
                    let results = []
                    response_data.forEach((item)=>{
                        results.push( item )
                        let sourceTag = item.sourceTag 
                        item.sourceTag = { tag: sourceTag }
                    })
                    
                    results.sort((a, b) => b.datetime - a.datetime);
                    this.rows = results
                    this.loaded = true;
                    
                }else{
                    //console.log("")
                }                
            })
            .then(function(){

                
            }.bind(this))
            
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error while fetching sources. Please reach out to us!'
                })

            }); //end axios 
            
        },
        
        formatDate(a){
            //return this.$moment.unix(a.datetime).format( 'HH:mm:ss MMM D, YYYY' )
            return helper.formatDate( a.datetime, 'HH:mm:ss MMM D, YYYY'  )
        },
    },
    computed:{
        getOrganizationID(){
            return this.$store.getters.getOrganizationID
        },
    }
}
</script>

<style >

</style>


// WEBPACK FOOTER //
// src/templates/leads/Clicksv2.vue